import React from "react";
import { Button, useTheme } from "@mui/material";
import type { SxProps, Theme } from "@mui/material/styles";

interface IconButtonProps {
  disabled?: boolean;
  onClick?: () => void;
  children: React.ReactNode;
  variant?: "text" | "outlined" | "contained";
  title?: string;
  sx?: SxProps<Theme>;
  width?: string;
  height?: string;
  type?: "button" | "submit" | "reset";
}

export const IconButton: React.FC<IconButtonProps> = ({
  disabled = false,
  onClick,
  children,
  variant = "outlined",
  title,
  sx = {},
  width = "30px",
  height = "30px",
  type = "button",
}) => {
  const theme = useTheme();

  return (
    <Button
      type={type}
      disabled={disabled}
      title={title}
      onClick={onClick}
      sx={{
        width,
        height,
        minWidth: "unset",
        padding: "0",
        borderRadius: "10px",
        borderColor: theme.palette.common.grey,
        ...sx,
      }}
      variant={variant}>
      {children}
    </Button>
  );
};
